// extracted by mini-css-extract-plugin
export default {"container":"TextArea-module__container--0IfVi","labelError":"TextArea-module__labelError--5N5q-"};